import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("membersite_token");
      setIsAuthenticated(!!token);
    };

    checkAuth();
    window.addEventListener("tokenUpdated", checkAuth);
    window.addEventListener("storage", checkAuth);

    return () => {
      window.removeEventListener("tokenUpdated", checkAuth);
      window.removeEventListener("storage", checkAuth);
    };
  }, []);

  return isAuthenticated;
};

export default useAuth;
